import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import type { ProxyVerificationSummary } from "./useProxyListActions";
import type { JSX } from "react";

interface ProxyVerificationProgressProps {
  kind: "starting" | "progress" | "completed" | "error";
  summary: ProxyVerificationSummary | null;
  errorMessage: string | null;
  onDismiss: () => void;
}

export function ProxyVerificationProgress(props: ProxyVerificationProgressProps) {
  let proxyVerificationProgress: JSX.Element | null;
  const { kind, summary, errorMessage, onDismiss } = props;
  if (kind === "starting") {
    proxyVerificationProgress = (
      <Alert severity="info" sx={{ mb: 2 }}>
        Запуск проверки прокси...
      </Alert>
    );
  } else {
    if (kind === "error") {
      proxyVerificationProgress = (
      <Alert severity="error" sx={{ mb: 2 }} action={<Button size="small" onClick={onDismiss}>Закрыть</Button>}>
        Ошибка проверки: {errorMessage}
      </Alert>
    );
    } else {
      if (kind === "completed" && summary) {
        proxyVerificationProgress = (
      <Alert severity="success" sx={{ mb: 2 }} action={<Button size="small" onClick={onDismiss}>Закрыть</Button>}>
        Проверка завершена: {summary.totalProxies} всего, {summary.activeCount} активных, {summary.inactiveCount} неактивных
      </Alert>
    );
      } else {
        if (kind === "progress" && summary) {
          const percent = summary.totalProxies > 0 ? (summary.checkedCount / summary.totalProxies) * 100 : 0;
          proxyVerificationProgress = (
      <Box sx={{ mb: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
          <Typography variant="body2">
            Проверка прокси: {summary.checkedCount} / {summary.totalProxies}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Активных: {summary.activeCount} | Неактивных: {summary.inactiveCount}
          </Typography>
        </Box>
        <LinearProgress variant="determinate" value={percent} />
      </Box>
    );
        } else {
          proxyVerificationProgress = null;
        }
      }
    }
  }
  return proxyVerificationProgress;
}
